import cns from "classnames";

const IconButton = ({
  className,
  children,
  onClick,
  ...rest
}: {
  className?: string;
  children: React.ReactNode;
  onClick?: () => void;
}) => {
  return (
    <button
      type="button"
      className={cns(
        "transition duration-75 focus:outline-none p-2",
        className
      )}
      onClick={onClick}
      {...rest}
    >
      {children}
    </button>
  );
};

export default IconButton;
